import Valuableclients from '../../pages/Valuableclients';

export default function HomeBrandsSection() {
  return (
    <section className="home-brands-section home-surface--light" aria-labelledby="home-brands-heading">
      <div className="client-carousel">
        <div className="container">
          <div className="home-brands-section__header">
            <p className="home-section__kicker">Trusted partners</p>
            <h2 id="home-brands-heading" className="heading-title">Brands we work with</h2>
            <p className="heading-text">
              Organizations that trust us with production websites, apps, and campaigns.
            </p>
          </div>
          <div className="theme-module clients-slider-module">
            <Valuableclients />
          </div>
        </div>
      </div>
    </section>
  );
}
